<template>
  <div
    class="d-post-image"
    @click.stop
  >
    <div
      class="image-container"
      @click.stop.prevent="openGallery"
    >
      <img
        :src="activity.source.image.medium.url"
        :title="activity.source.content"
      >

      <span class="gallery-button button button-translucent button-sm">
        <DuiIconExpand class="icon-lg" />
      </span>
    </div>

    <vue-gallery
      :id="`gallery-${ _uid }`"
      :images="[activity.source.image.large.url]"
      :index="galleryIndex"
      @close="closeGallery"
    />
  </div>
</template>

<script>
import VueGallery from 'vue-gallery';

export default {
  components: {
    VueGallery,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    galleryIndex: null,
  }),
  methods: {
    closeGallery() {
      this.$set(this, 'galleryIndex', null);
    },

    openGallery() {
      this.$set(this, 'galleryIndex', 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-post-image {
  text-align: center;

  .image-container {
    display: inline-flex;
    position: relative;

    img {
      border-radius: $border-radius-lg;
    }

    .gallery-button {
      bottom: $_2em;
      position: absolute;
      right: $_2em;
      z-index: 1;
    }
  }
}
</style>
